<template>
  <div>
    <new-bed @created="getBeds" />
    <new-type-of-hosting @created="getTypeOfHostings" />
    <b-modal
      size="xl"
      id="new_resident"
      title="NOVO RESIDENTE"
      hide-footer
      no-close-on-backdrop
      @show="evOnShow"
      @shown="evOnShown"
      @hide="evOnHide"
    >
      <form @submit.prevent="evOnSubmit">
        <b-overlay :show="loading" opacity="0.99">
          <nav>
            <div class="nav nav-tabs" id="nav-tab" role="tablist">
              <a
                @click="step = 'INFORMATION'"
                v-if="permission('write', 'resident')"
                :class="[
                  'nav-link link-annotation-care',
                  step == 'INFORMATION' && 'active',
                ]"
                id="nav-informacoes"
                data-toggle="tab"
                href="#informacoes"
                role="tab"
                aria-controls="informacoes"
                :aria-selected="step == 'INFORMATION'"
                >INFORMAÇÕES</a
              >
              <a
                @click="step = 'DOCUMENTS'"
                v-if="permission('read', 'resident_documents')"
                :class="[
                  'nav-link link-annotation-care',
                  step == 'DOCUMENTS' && 'active',
                ]"
                id="nav-documentos"
                data-toggle="tab"
                href="#documentos"
                role="tab"
                aria-controls="documentos"
                :aria-selected="step == 'DOCUMENTS'"
                >DOCUMENTOS</a
              >
              <a
                @click="step = 'ADDRESS'"
                v-if="permission('read', 'resident_address')"
                :class="[
                  'nav-link link-annotation-care',
                  step == 'ADDRESS' && 'active',
                ]"
                id="nav-endereco"
                data-toggle="tab"
                href="#endereco"
                role="tab"
                aria-controls="endereco"
                :aria-selected="step == 'ADDRESS'"
                >ENDEREÇO</a
              >
              <a
                @click="step = 'ACCOMMODATION'"
                v-if="permission('read', 'resident_accommodation')"
                :class="[
                  'nav-link link-annotation-care',
                  step == 'ACCOMMODATION' && 'active',
                ]"
                id="nav-hospedagem"
                data-toggle="tab"
                href="#hospedagem"
                role="tab"
                aria-controls="hospedagem"
                :aria-selected="step == 'ACCOMMODATION'"
                >HOSPEDAGEM</a
              >
              <a
                @click="step = 'PHOTOGRAPH'"
                v-if="permission('edit', 'resident_photo')"
                :class="[
                  'nav-link link-annotation-care',
                  step == 'PHOTOGRAPH' && 'active',
                ]"
                id="nav-foto"
                data-toggle="tab"
                href="#foto"
                role="tab"
                aria-controls="foto"
                :aria-selected="step == 'PHOTOGRAPH'"
                >FOTO</a
              >
            </div>
          </nav>
          <div class="tab-content">
            <div
              v-if="permission('write', 'resident')"
              :class="['tab-pane fade', step == 'INFORMATION' && 'show active']"
              id="informacoes"
              role="tabpanel"
              aria-labelledby="nav-informacoes"
            >
              <div class="row">
                <div
                  v-if="false"
                  class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6"
                >
                  <label>Vincular cliente</label>
                  <select v-model="finance_client_id" class="form-control">
                    <option value>SELECIONE...</option>
                    <option
                      v-for="item in finance_client"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ String(item.name).toUpperCase() }}
                    </option>
                  </select>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-7 col-sm-8 col-12">
                  <label-required-field label="Nome" />
                  <input
                    type="text"
                    ref="autofocus"
                    v-model="name"
                    class="form-control"
                  />
                </div>
                <div class="col-xl-4 col-lg-4 col-md-3 col-sm-3 col-12">
                  <label>Número de prontuário</label>
                  <input
                    type="text"
                    ref="autofocus"
                    v-model="medical_record_number"
                    class="form-control"
                  />
                </div>
                <div class="col-xl-2 col-lg-2 col-md-5 col-sm-4 col-12">
                  <label-required-field label="Gênero" />
                  <select v-model="gender_id" class="form-control">
                    <option value>SELECIONE...</option>
                    <option
                      v-for="value in genders"
                      :key="value.id"
                      :value="value.id"
                    >
                      {{ String(value.name).toUpperCase() }}
                    </option>
                  </select>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
                  <label-required-field label="Data de nascimento" />
                  <input
                    type="date"
                    v-model="date_of_birth"
                    class="form-control"
                  />
                  <span>{{
                    date_of_birth && date_of_birth.length == 10
                      ? "Idade: " +
                        getAge(formatDateToUs(date_of_birth, true)) +
                        " anos"
                      : ""
                  }}</span>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
                  <label-required-field label="Status" />
                  <select v-model="status_type_id" class="form-control">
                    <option value>SELECIONE...</option>
                    <option
                      v-for="value in statusTypes"
                      :key="value.id"
                      :value="value.id"
                    >
                      {{ String(value.name).toUpperCase() }}
                    </option>
                  </select>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                  <label-required-field label="Grau de Dependência" />
                  <select
                    v-model="degree_of_dependence_id"
                    class="form-control"
                  >
                    <option value>SELECIONE...</option>
                    <option
                      v-for="item in degrees_of_dependence"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ item.name }}
                    </option>
                  </select>
                  <label>Tipo de alimentação</label>
                  <chrome-speech-to-text-textarea
                    rows="4"
                    max-rows="10"
                    v-model="type_of_food"
                  />
                </div>
                <div class="col-xl-4 col-lg-4 col-md-3 col-sm-3 col-12">
                  <label>Patologia (Doença)</label>
                  <chrome-speech-to-text-textarea
                    rows="4"
                    max-rows="10"
                    v-model="pathology"
                  />
                </div>
                <div class="col-xl-4 col-lg-4 col-md-3 col-sm-3 col-12">
                  <label>Alergias diversas</label>
                  <chrome-speech-to-text-textarea
                    rows="4"
                    max-rows="10"
                    v-model="miscellaneous_allergies"
                  />
                </div>
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                  <label>Apelido</label>
                  <input type="text" v-model="nickname" class="form-control" />
                </div>
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                  <label>Naturalidade</label>
                  <input
                    type="text"
                    v-model="naturalness"
                    class="form-control"
                  />
                </div>
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                  <label>Estado civil</label>
                  <select v-model="marital_status_id" class="form-control">
                    <option value>SELECIONE...</option>
                    <option
                      v-for="value in maritalStatus"
                      :key="value.id"
                      :value="value.id"
                    >
                      {{ String(value.name).toUpperCase() }}
                    </option>
                  </select>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                  <label>Religião</label>
                  <input type="text" v-model="religion" class="form-control" />
                </div>
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                  <label>Profissão</label>
                  <input
                    type="text"
                    v-model="profession"
                    class="form-control"
                  />
                </div>
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                  <label>Escolaridade</label>
                  <input type="text" v-model="schooling" class="form-control" />
                </div>
                <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
                  <label>Nome do pai</label>
                  <input
                    type="text"
                    v-model="fathers_name"
                    class="form-control"
                  />
                </div>
                <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
                  <label>Nome da mãe</label>
                  <input
                    type="text"
                    v-model="mothers_name"
                    class="form-control"
                  />
                </div>
                <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
                  <label>Cônjuge</label>
                  <input type="text" v-model="spouse" class="form-control" />
                </div>
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                  <label>Observações</label>
                  <chrome-speech-to-text-textarea
                    rows="4"
                    max-rows="10"
                    v-model="comments"
                  />
                </div>
              </div>
            </div>
            <div
              v-if="permission('read', 'resident_documents')"
              :class="['tab-pane fade', step == 'DOCUMENTS' && 'show active']"
              id="documentos"
              role="tabpanel"
              aria-labelledby="nav-documentos"
            >
              <div class="row">
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                  <label>CPF</label>
                  <BInputCPF v-model="cpf" />
                </div>
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                  <label>RG</label>
                  <input type="text" v-model="rg" class="form-control" />
                </div>
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                  <label>Orgão expedidor</label>
                  <input
                    type="text"
                    v-model="issuing_body"
                    class="form-control"
                  />
                </div>
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                  <label>Número do cartão SUS</label>
                  <input
                    type="text"
                    v-model="SUS_card_number"
                    class="form-control"
                  />
                </div>
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                  <label>Número do benefício do INSS</label>
                  <input
                    type="text"
                    v-model="INSS_benefit_number"
                    class="form-control"
                  />
                </div>
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                  <label>Tipo de benefício INSS</label>
                  <b-input type="text" v-model="type_of_INSS_benefit" />
                </div>
                <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
                  <label>Situação do benefício do INSS</label>
                  <b-select
                    :disabled="!permission('edit', 'resident')"
                    v-model="inss_benefit_status_id"
                  >
                    <b-select-option value>ESCOLHA</b-select-option>
                    <b-select-option
                      v-for="item in inss_benefit_status"
                      :value="item.id"
                      :key="item.id"
                    >
                      {{ item.name }}
                    </b-select-option>
                  </b-select>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                  <label>Valor do benefício do INSS</label>
                  <input
                    type="text"
                    v-on:keyup="handleValueINSSBenefitAmount"
                    v-model="INSS_benefit_amount"
                    class="form-control"
                  />
                </div>
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                  <label>Data da atualização do INSS</label>
                  <input
                    type="date"
                    v-model="INSS_update_date"
                    class="form-control"
                  />
                </div>
              </div>
            </div>
            <div
              v-if="permission('read', 'resident_address')"
              :class="['tab-pane fade', step == 'ADDRESS' && 'show active']"
              id="endereco"
              role="tabpanel"
              aria-labelledby="nav-endereco"
            >
              <div class="row">
                <div class="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12">
                  <label>CEP</label>
                  <BInputCEP v-model="cep" @retrieved="evOnCEPRetrieved" />
                </div>
                <div class="col-xl-7 col-lg-7 col-md-6 col-sm-8 col-12">
                  <label>Endereço</label>
                  <input type="text" v-model="address" class="form-control" />
                </div>
                <div class="col-xl-2 col-lg-2 col-md-2 col-sm-4 col-12">
                  <label>Nº</label>
                  <input
                    type="text"
                    v-model="number_address"
                    class="form-control"
                  />
                </div>
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                  <label>Bairro</label>
                  <input
                    type="text"
                    v-model="neighborhood"
                    class="form-control"
                  />
                </div>
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                  <label>Cidade</label>
                  <input type="text" v-model="city" class="form-control" />
                </div>
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                  <label>Estado</label>
                  <select v-model="uf_id" class="form-control">
                    <option value>SELECIONE...</option>
                    <option
                      v-for="value in ufs"
                      :key="value.id"
                      :value="value.id"
                    >
                      {{ value.name }}
                    </option>
                  </select>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                  <label>Referência</label>
                  <input type="text" v-model="reference" class="form-control" />
                </div>
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                  <label>Complemento</label>
                  <input
                    type="text"
                    v-model="complement"
                    class="form-control"
                  />
                </div>
              </div>
            </div>
            <div
              v-if="permission('read', 'resident_accommodation')"
              :class="[
                'tab-pane fade',
                step == 'ACCOMMODATION' && 'show active',
              ]"
              id="hospedagem"
              role="tabpanel"
              aria-labelledby="nav-hospedagem"
            >
              <div class="row">
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                  <label>TIPO DE HOSPEDAGEM</label>
                  <div class="input-group">
                    <select
                      class="form-control"
                      v-model="type_of_hosting_id"
                      @change="handleChangeTypeOfStay($event.target.value)"
                    >
                      <option
                        v-for="(item, key) in types_of_stay"
                        :key="key"
                        :value="item.value"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <div class="input-group-pprend">
                      <v-btn
                        v-if="permission('write', 'type_of_hosting')"
                        type="button"
                        class="btn-add ml-1"
                        @click="$bvModal.show('new_type_of_hosting')"
                      >
                        <i class="fas fa-plus mr-2 text-twenty"></i>
                        NOVA HOSPEDAGEM
                      </v-btn>
                    </div>
                  </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
                  <label>DATA DA HOSPEDAGEM</label>
                  <input
                    type="date"
                    v-model="date_of_reception"
                    class="form-control"
                  />
                </div>
                <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12">
                  <label>LEITO DO RESIDENTE</label>
                  <div class="input-group">
                    <select v-model="bed_id" class="form-control">
                      <option value>SELECIONE...</option>
                      <option
                        v-for="value in beds"
                        :key="value.id"
                        :value="value.id"
                      >
                        (Nº) {{ value.number }} - (And.) {{ value.walk }} -
                        (QRT) {{ value.bedroom }} - (ALA/Setor)
                        {{ value.ward_or_sector }}
                      </option>
                    </select>
                    <div class="input-group-prepend">
                      <v-btn
                        type="button"
                        class="btn-add ml-1"
                        @click="$bvModal.show('new_bed')"
                      >
                        <i class="fas fa-plus mr-2 text-twenty"></i> NOVO LEITO
                      </v-btn>
                    </div>
                  </div>
                </div>
                <div class="col-xl-3 col-lg-4 col-md-12 col-sm-12 col-12">
                  <label>VALOR DA MENSALIDADE</label>
                  <select v-model="income_monthly_fee" class="form-control">
                    <option value>SELECIONE...</option>
                    <option
                      v-for="value in hosting_type_values"
                      :key="value.id"
                      :value="value.value"
                    >
                      {{ formatPrice(value.value) }} - (Desc)
                      {{ value.description }}
                    </option>
                  </select>
                </div>
                <div class="col-xl-9 col-lg-8 col-md-12 col-sm-12 col-12">
                  <label>Motivo da hospedagem</label>
                  <input
                    type="text"
                    v-model="reason_for_the_reception"
                    class="form-control"
                  />
                </div>
              </div>
            </div>
            <div
              v-if="permission('edit', 'resident_photo')"
              :class="['tab-pane fade', step == 'PHOTOGRAPH' && 'show active']"
              id="foto"
              role="tabpanel"
              aria-labelledby="nav-foto"
            >
              <div class="col-md-12">
                <p class="mb-0 mt-3 text-info-img">
                  Tamanho máximo <strong>10MB</strong>
                </p>
                <p class="text-info-img">
                  Formatos: <strong>JPG, JPEG, PJPEG</strong> e
                  <strong>PNG</strong>
                </p>
              </div>
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                <input
                  type="file"
                  class="form-control-file"
                  @change="isValidPhotoByCreate($event)"
                />
              </div>
            </div>
          </div>
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <warning-required-fields />
            <errors-messages :errors="errors" />
          </div>
          <div
            class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-right"
          >
            <v-btn :disabled="loading" type="submit" class="btn-save">
              <i class="fas fa-save mr-2 text-twenty"></i>
              {{ loading ? "Carregando" : "SALVAR" }}
            </v-btn>
          </div>
        </b-overlay>
      </form>
    </b-modal>
  </div>
</template>

<script>
import api from "../../services/api";
import ChromeSpeechToTextTextarea from "../Components/ChromeSpeechToTextTextarea.vue";
import ErrorsMessages from "../Components/ErrorsMessages.vue";
import LabelRequiredField from "../Components/LabelRequiredField.vue";
import WarningRequiredFields from "../Components/WarningRequiredFields.vue";
import permission from "../../lib/permission";
import { formatValueOnKeyUp, formatPrice } from "../../lib/format";
import toast from "../../lib/ToastNotification";
import NewBed from "../beds/new-bed.vue";
import NewTypeOfHosting from "../types-of-hosting/new-type-of-hosting.vue";
import { getAge } from "../../lib/getAgeByDate";
import { formatDateToUs } from "../../lib/format";
import BInputCEP from "../Components/BInputCEP.vue";
import BInputCPF from "../Components/BInputCPF.vue";

export default {
  name: "NewResident",

  components: {
    ChromeSpeechToTextTextarea,
    LabelRequiredField,
    WarningRequiredFields,
    ErrorsMessages,
    NewBed,
    NewTypeOfHosting,
    BInputCEP,
    BInputCPF,
  },

  props: {
    finance_client: Array,
  },

  data() {
    return {
      errors: [],
      loading: false,
      finance_client_id: "",
      beds: [],
      genders: [],
      statusTypes: [],
      degrees_of_dependence: [],
      maritalStatus: [],
      ufs: [],
      types_of_stay: [],
      hosting_type_values: [],
      inss_benefit_status: [],

      step: "INFORMATION",

      /** INFORMAÇÕES */
      name: "",
      medical_record_number: "",
      gender_id: "",
      date_of_birth: "",
      status_type_id: "",
      degree_of_dependence_id: "",
      type_of_food: "",
      pathology: "",
      miscellaneous_allergies: "",
      nickname: "",
      naturalness: "",
      marital_status_id: "",
      religion: "",
      profession: "",
      schooling: "",
      fathers_name: "",
      mothers_name: "",
      spouse: "",
      comments: "",

      /** DOCUMENTOS */
      cpf: "",
      rg: "",
      issuing_body: "",
      SUS_card_number: "",
      INSS_benefit_number: "",
      type_of_INSS_benefit: "",
      inss_benefit_status_id: "",
      INSS_benefit_amount: "",
      INSS_update_date: "",

      /** ENDEREÇO */
      cep: "",
      address: "",
      number_address: "",
      neighborhood: "",
      city: "",
      uf_id: "",
      reference: "",
      complement: "",

      /** HOSPEDAGEM */
      type_of_hosting_id: null,
      date_of_reception: "",
      bed_id: "",
      income_monthly_fee: "",
      reason_for_the_reception: "",

      /** FOTO */
      photo: null,
    };
  },

  created() {
    this.evOnCreated();
  },

  methods: {
    permission,
    formatPrice,
    getAge,
    formatDateToUs,

    async evOnCreated() {
      await this.getBeds();
      await this.getGenders();
      await this.getTypeOfHostings();
      await this.getINSSBenefitStatus();
      await this.getCustomers();
      await this.getStatusResidents();
      await this.getAllBedsWithNoBond();
      await this.getMaritalStatus();
      await this.getUfs();
      await this.getBillingTypeOfHostingTypes();
      await this.getDegreesOfDependence();
    },

    async evOnShow() {
      this.step = "INFORMATION";

      /** INFORMAÇÕES */
      this.name = "";
      this.medical_record_number = "";
      this.gender_id = "";
      this.date_of_birth = "";
      this.status_type_id = "";
      this.degree_of_dependence_id = "";
      this.type_of_food = "";
      this.pathology = "";
      this.miscellaneous_allergies = "";
      this.nickname = "";
      this.naturalness = "";
      this.marital_status_id = "";
      this.religion = "";
      this.profession = "";
      this.schooling = "";
      this.fathers_name = "";
      this.mothers_name = "";
      this.spouse = "";
      this.comments = "";

      /** DOCUMENTOS */
      this.cpf = "";
      this.rg = "";
      this.issuing_body = "";
      this.SUS_card_number = "";
      this.INSS_benefit_number = "";
      this.type_of_INSS_benefit = "";
      this.inss_benefit_status_id = "";
      this.INSS_benefit_amount = "";
      this.INSS_update_date = "";

      /** ENDEREÇO */
      this.cep = "";
      this.address = "";
      this.number_address = "";
      this.neighborhood = "";
      this.city = "";
      this.uf_id = "";
      this.reference = "";
      this.complement = "";

      /** HOSPEDAGEM */
      this.type_of_hosting_id = null;
      this.date_of_reception = "";
      this.bed_id = "";
      this.income_monthly_fee = "";
      this.reason_for_the_reception = "";

      /** FOTO */
      this.photo = null;
    },

    async evOnShown() {
      this.$refs.autofocus.focus();
    },

    async evOnHide() {},

    async evOnSubmit() {
      try {
        this.loading = true;

        const params = {
          /** INFORMAÇÕES */
          name: this.name,
          medical_record_number: this.medical_record_number,
          gender_id: this.gender_id,
          date_of_birth: this.date_of_birth,
          status_type_id: this.status_type_id,
          degree_of_dependence_id: this.degree_of_dependence_id,
          type_of_food: this.type_of_food,
          pathology: this.pathology,
          miscellaneous_allergies: this.miscellaneous_allergies,
          nickname: this.nickname,
          naturalness: this.naturalness,
          marital_status_id: this.marital_status_id,
          religion: this.religion,
          profession: this.profession,
          schooling: this.schooling,
          fathers_name: this.fathers_name,
          mothers_name: this.mothers_name,
          spouse: this.spouse,
          comments: this.comments,

          /** DOCUMENTOS */
          cpf: this.cpf,
          rg: this.rg,
          issuing_body: this.issuing_body,
          SUS_card_number: this.SUS_card_number,
          INSS_benefit_number: this.INSS_benefit_number,
          type_of_INSS_benefit: this.type_of_INSS_benefit,
          inss_benefit_status_id: this.inss_benefit_status_id,
          INSS_benefit_amount: this.INSS_benefit_amount,
          INSS_update_date: this.INSS_update_date,

          /** ENDEREÇO */
          cep: this.cep,
          address: this.address,
          number_address: this.number_address,
          neighborhood: this.neighborhood,
          city: this.city,
          uf_id: this.uf_id,
          reference: this.reference,
          complement: this.complement,

          /** HOSPEDAGEM */
          type_of_hosting_id: this.type_of_hosting_id,
          date_of_reception: this.date_of_reception,
          bed_id: this.bed_id,
          income_monthly_fee: this.income_monthly_fee,
          reason_for_the_reception: this.reason_for_the_reception,
          client_id: this.finance_client_id,
        };
        const response = await api.post("/rest-home/resident", params);
        const { error, errors, resident_id, step } = response.data;

        if (error) {
          this.errors = errors;

          if (
            [
              "INFORMATION",
              "DOCUMENTS",
              "ADDRESS",
              "ACCOMMODATION",
              "PHOTOGRAPH",
            ].includes(step)
          )
            this.step = step;
        } else {
          if (this.photo) await this.uploadPhoto(resident_id);
          this.$bvModal.hide("new_resident");
          this.$emit("created");
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async getBeds() {
      try {
        const response = await api.get("/rest-home/bed/all");

        const { error, errors, beds } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.beds = beds;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getGenders() {
      try {
        const response = await api.get("/genders");

        const { error, errors, genders } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.genders = genders;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getTypeOfHostings() {
      try {
        const { rest_home_id } = this;

        let params = {
          rest_home_id,
        };

        const response = await api.get("/rest-home/type-of-hosting/all", {
          params,
        });

        const { error, errors, types } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.types_of_stay = types;

          if (types.length > 0) {
            this.type_of_hosting_id = types[0].value;
            this.handleChangeTypeOfStay(types[0].value);
          }

          this.typeOfHostings = types;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getCustomers() {
      try {
        const response = await api.get("/rest-home/customers");

        const { error, errors, customers } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.customers = customers;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getStatusResidents() {
      try {
        const { rest_home_id } = this;

        let params = {
          rest_home_id,
          type: "RESIDENTE",
        };

        const response = await api.get("/rest-home/type/status/all", {
          params,
        });

        const { error, errors, status } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.statusTypes = status;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getAllBedsWithNoBond() {
      try {
        const { rest_home_id } = this;
        const response = await api.get("/rest-home/bed/all-beds-with-no-bond", {
          params: { rest_home_id },
        });

        const { error, errors, beds } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.beds = beds;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getMaritalStatus() {
      try {
        const response = await api.get("/rest-home/marital-status/all");

        const { error, errors, marital_status } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.maritalStatus = marital_status;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getUfs() {
      try {
        const response = await api.get("/ufs");

        const { error, errors, ufs } = response.data;
        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.ufs = ufs;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getBillingTypeOfHostingTypes() {
      try {
        const response = await api.get("/rest-home/type-of-hosting/types");

        const { error, errors, types } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.billing_type_of_hosting_types = types;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getDegreesOfDependence() {
      try {
        this.loading = true;

        const response = await api.get("/default/degrees-of-dependence");
        const { error, errors, degrees_of_dependence } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.degrees_of_dependence = degrees_of_dependence;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    async getINSSBenefitStatus() {
      try {
        this.loading = true;

        const response = await api.get(
          "/rest-home/resident/inss-benefit-status"
        );
        const { error, errors, inss_benefit_status } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.inss_benefit_status = inss_benefit_status;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async handleChangeTypeOfStay(type_of_hosting_id) {
      try {
        let params = {
          type_of_hosting_id,
        };

        const response = await api.get("/rest-home/hosting-type-value/all", {
          params,
        });

        const { error, errors, hosting_type_value } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.hosting_type_values = hosting_type_value;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async evOnCEPRetrieved(value) {
      this.cep = value.cep;
      this.city = value.localidade || this.city;
      this.neighborhood = value.bairro || this.neighborhood;
      // this.complement = value.complemento || this.complement;
      this.address = value.logradouro || this.address;

      const matched_uf = this.ufs.find(
        (item) => item.initials.toLowerCase() === value.uf.toLowerCase()
      );
      if (matched_uf) this.uf_id = matched_uf.id;
    },

    async evOnPhotoSelected() {
      try {
        this.loading = true;
        this.errors = [];

        if (!this.photo) {
          this.photo = null;
          this.errors.push("Informe a foto");
          this.loading = false;
          return;
        }

        const allowedMimes = [
          "image/jpg",
          "image/jpeg",
          "image/pjpeg",
          "image/png",
        ];

        if (!allowedMimes.includes(this.photo.type)) {
          this.photo = null;
          this.errors.push("Formato de arquivo inválido");
          this.loading = false;
          return;
        }

        var limitSize = 10 * 1024 * 1024;

        if (this.photo.size > limitSize) {
          this.photo = null;
          this.errors.push("Suportado até 10MB");
          return;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    async uploadPhoto(resident_id) {
      try {
        const formData = new FormData();
        formData.append("id", resident_id);
        formData.append("photo", this.photo, this.photo.name);

        const response = await api.post("/rest-home/resident/photo", formData);
        const { error } = response.data;

        if (error) toast("Não foi possível definir a foto", "success");
      } catch (error) {
        console.log(error);
      }
    },

    isValidPhotoByCreate(e) {
      try {
        e.preventDefault();

        let photo = e.target.files[0];

        if (!photo) {
          this.photo = null;
          this.errors = [
            { id: this.errors.length + 1, message: "Informe a foto" },
          ];
          return;
        }

        const allowedMimes = [
          "image/jpg",
          "image/jpeg",
          "image/pjpeg",
          "image/png",
        ];

        if (!allowedMimes.includes(photo.type)) {
          this.photo = null;
          this.errors = [
            {
              id: this.errors.length + 1,
              message: "Formato de arquivo inválido",
            },
          ];
          return;
        }

        var limitSize = 10 * 1024 * 1024;

        if (photo.size > limitSize) {
          this.photo = null;
          this.errors = [
            { id: this.errors.length + 1, message: "Suportado até 10MB" },
          ];
          return;
        }

        this.photo = photo;
        this.errors = [];
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    handleValueINSSBenefitAmount: function (e) {
      this.INSS_benefit_amount = formatValueOnKeyUp(e.target.value);
    },
  },
};
</script>

<style>
</style>